import { createConfigurationApi, createFileApi, createAuthApi } from "@repo/services";

const configUrl = import.meta.env.VITE_CONFIG_API_BASE_URL;
const fileUrl = import.meta.env.VITE_FILE_API_BASE_URL;
const authUrl = import.meta.env.VITE_AUTH_API_BASE_URL;

if (!configUrl) throw new Error("Missing VITE_CONFIG_API_BASE_URL");
if (!fileUrl) throw new Error("Missing VITE_FILE_API_BASE_URL");
if (!authUrl) throw new Error("Missing VITE_AUTH_API_BASE_URL");

export const configurationApi: ReturnType<typeof createConfigurationApi> = createConfigurationApi(configUrl);
export const fileApi: ReturnType<typeof createFileApi> = createFileApi(fileUrl);
export const authApi: ReturnType<typeof createAuthApi> = createAuthApi(authUrl);
